import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { UserService } from "src/app/core/services/user.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { GenericLabelValue } from "src/app/shared/models/DTO/GenericLabelValue.dto";
import { AppMessageSeverity } from "src/app/shared/models/enums/AppMessageSeverity.enum";
import { CanvasTypeOptions } from "src/app/shared/models/enums/CanvasTypeOptions.enum";
import { OOCanvas } from "src/app/shared/models/oo-canvas";

@Component({
	selector: "app-canvas-new-prompt",
	templateUrl: "./canvas-new-prompt.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class CanvasNewPromptComponent implements OnInit {
	canvas: OOCanvas;

	loadingCanvases = false;

	newCanvasType: number = 0;
	newCanvasTypeOptions: GenericLabelValue[] = [
		{
			label: "Blank",
			value: CanvasTypeOptions.BLANK,
		},
		{
			label: "Shared",
			value: CanvasTypeOptions.SHARED,
		},
		{
			label: "Duplicate",
			value: CanvasTypeOptions.DUPLICATE,
		},
	];

	selectableCanvases: OOCanvas[];
	sharedFromVenueKey: number;
	sharedFromCanvasKey: number;

	@Input() newRecord: boolean;
	@Output() newRecordChange = new EventEmitter<boolean>();

	@Input() canvasKey: number;
	@Output() canvasKeyChange = new EventEmitter<number>();

	constructor(public app: AppService, public focuslink: FocuslinkService, public venueService: OOVenueService, public userService: UserService) {}

	ngOnInit(): void {
		this.canvas = new OOCanvas({ venueKey: this.venueService.subscriptionVenue.value.key, online: true });
	}

	async getCanvasForVenues(venueKey) {
		this.loadingCanvases = true;
		const resp = await this.focuslink.getOOCanvases(venueKey);
		this.selectableCanvases = resp.map((i) => new OOCanvas(i));
		this.loadingCanvases = false;
	}

	canvasKeyAssign(): number {
		console.log("enter canvas key assign");
		for (let i = 100001; i < 9999999; i++) {
			console.log(i);
			if (!this.venueService.subscriptionOOcanvas.value.some((j) => j.canvasKey === i)) {
				console.log(`new canvas canvasKey = ${i}`);
				return i;
			}
		}
	}

	clearToSave() {
		if (!this.canvas.name) {
			return false;
		}

		switch (this.newCanvasType) {
			case 0:
				if (!this.canvas.name) {
					return false;
				}
				return true;
			case 1:
				if (this.sharedFromVenueKey && this.sharedFromCanvasKey) return true;
				return false;
			case 2:
				if (this.sharedFromCanvasKey) return true;
				return false;
			default:
				return false;
		}
	}

	duplicateCanvas(sourceCanvasKey: number): OOCanvas {
		const source = this.venueService.subscriptionOOcanvas.value.find((i) => i.canvasKey === sourceCanvasKey);
		if (!source) {
			this.app.msgSvc.add({ severity: AppMessageSeverity.RED, summary: "", detail: `Source canvas not found` });
		}

		const canvasKey = this.canvas.canvasKey;
		const canvasName = this.canvas.name;
		const displayName = this.canvas.displayName;

		Object.assign(this.canvas, source);
		this.canvas.name = canvasName;
		this.canvas.displayName = displayName;
		this.canvas.canvasKey = canvasKey;

		this.canvas.menuItems?.forEach((cmi) => {
			cmi.canvasKey = this.canvas.canvasKey;
		});

		return this.canvas;
	}

	async onSave() {
		this.canvas.canvasKey = this.canvasKeyAssign();
		switch (this.newCanvasType) {
			case CanvasTypeOptions.BLANK:
				break;
			case CanvasTypeOptions.DUPLICATE:
				this.canvas = this.duplicateCanvas(this.sharedFromCanvasKey);
				break;
			case CanvasTypeOptions.SHARED:
				this.canvas.sharedFrom = `${this.sharedFromVenueKey}_${this.sharedFromCanvasKey}`;
		}

		await this.venueService.canvaseSave(this.canvas);

		if (this.newCanvasType === CanvasTypeOptions.DUPLICATE && this.canvas.menuItems?.length > 0) {
			const promiseList: any = [];
			this.app.loading(true);
			this.canvas.menuItems.forEach((cmi) => {
				promiseList.push(this.venueService.canvasMenuItemSave(cmi));
			});
			await Promise.all(promiseList);
			this.app.loading(false);
			this.venueService.ooCanvases.find((i) => i.canvasKey === this.canvas.canvasKey).menuItems = this.canvas.menuItems;
		}

		this.canvasKeyChange.emit(this.canvas.canvasKey);
		this.newRecord = false;
		this.newRecordChange.emit(false);
	}
}
